<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      max-width="100vw"
      fullscreen
    >
      <div class="modal-zoom">
        <v-card>
          <v-card-text :class="{ 'original-size': originalSize }">
            <div
              v-if="parseInt(modals.file.categories, 10) === 1"
              class="flag-container"
            >
              <div class="flag">
                {{ $t("\n                Draft\n              ") }}
              </div>
            </div>
            <div v-if="!modals.file.view_type">
              <v-carousel
                v-if="relatedFiles.length > 1"
                v-model="currentIndex"
                height="100%"
                hide-delimiters
                :show-arrows="false"
              >
                <v-carousel-item
                  v-for="(item, i) in relatedFiles"
                  :key="i"
                >
                  <img
                    v-if="isImage(displayFileAt(i))"
                    :src="displayFileAt(i)"
                    :class="`rotate_images__position_${rotatePositionAt(i)}`"
                    @error="onImgError(displayFileAt(i))"
                  />
                  <video
                    v-else-if="isVideo(displayFileAt(i))"
                    width="100%"
                    height="100%"
                    controls
                  >
                    <source
                      :src="displayFileAt(i)"
                      :type="getVideoType(displayFileAt(i))"
                    >{{ $t("\n                    Your browser does not support the video tag.\n                  ") }}</video>
                </v-carousel-item>
              </v-carousel>
              <template v-else>
                <img
                  v-if="isImage(selectedZoomUrl)"
                  :src="selectedZoomUrl"
                  :class="`rotate_images__position_${selectedZoomRotatePosition}`"
                  @error="onImgError(selectedZoomUrl)"
                />
                <video
                  v-else-if="isVideo(selectedZoomUrl)"
                  width="100%"
                  height="100%"
                  controls
                >
                  <source
                    :src="selectedZoomUrl"
                    :type="getVideoType(selectedZoomUrl)"
                  >{{ $t("\n                  Your browser does not support the video tag.\n                ") }}</video>
              </template>
            </div>
            <iframe
              v-else
              id="inner_iframe"
              src="/books/comic-book-v2/?v=8"
              class="iframe-modal"
              :title="$t(&quot;Comic&quot;)"
              frameborder="0"
              allowtransparency="true"
            ></iframe>
          </v-card-text>
          <v-btn
            v-if="relatedFiles.length > 1 && !modals.file.view_type"
            fab
            dark
            small
            class="nav-arrow nav-arrow-prev"
            @click.stop="prevImage"
          >
            <v-icon dark>
              {{ mdiChevronLeft }}
            </v-icon>
          </v-btn>
          <v-btn
            v-if="relatedFiles.length > 1 && !modals.file.view_type"
            fab
            dark
            small
            class="nav-arrow nav-arrow-next"
            @click.stop="nextImage"
          >
            <v-icon dark>
              {{ mdiChevronRight }}
            </v-icon>
          </v-btn>
          <v-btn
            v-if="!modals.file.view_type"
            fab
            dark
            small
            color="primary"
            class="btn-original-size"
            :title="originalSize ? $t(&quot;Fit to screen&quot;) : $t(&quot;Show at original size&quot;)"
            @click.stop="toggleOriginalSize"
          >
            <v-icon dark>
              {{ originalSize ? mdiFitToPageOutline : mdiImageSizeSelectActual }}
            </v-icon>
          </v-btn>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="text-muted text-center mx-auto">
              <small>{{ modals.file.name }} - {{ formatDate(modals.file.created_at) }}</small>
            </div>
            <v-spacer></v-spacer>
            <v-btn
              @click="$emit('closingModal', false)"
            >
              {{ $t("\n              Close\n            ") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-dialog>
  </v-row>
</template>

<script>
import {
  mdiImageSizeSelectActual, mdiFitToPageOutline, mdiChevronLeft, mdiChevronRight,
} from '@mdi/js'

export default {
  props: ['modals'],
  data() {
    return {
      dialog: true,
      currentIndex: 0,
      originalSize: false,
      mdiImageSizeSelectActual,
      mdiFitToPageOutline,
      mdiChevronLeft,
      mdiChevronRight,
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June',	'July',	'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
      endpoint: process.env.VUE_APP_ROOT_API,
      failedImages: {},
      scrollLockState: null,
    }
  },
  computed: {
    relatedFiles() {
      return this.modals.file.related_files || []
    },
    selectedZoomIndex() {
      const idx = Number.parseInt(this.modals.file.zoomIndex, 10)

      return Number.isInteger(idx) && idx >= 0 ? idx : 0
    },
    selectedZoomUrl() {
      if (this.modals.file.zoomUrl) return this.modals.file.zoomUrl
      const relatedFiles = this.modals.file.related_files || []

      return relatedFiles[this.selectedZoomIndex] || relatedFiles[0] || ''
    },
    selectedZoomRotatePosition() {
      const rotatePositions = this.modals.file.rotate_position || []

      return rotatePositions[this.selectedZoomIndex] || rotatePositions[0] || 0
    },
  },
  mounted() {
    this.currentIndex = this.selectedZoomIndex
    this.lockBackgroundScroll()
    if (this.modals.file.view_type) {
      this.callIframe()
    }
  },
  beforeDestroy() {
    this.unlockBackgroundScroll()
  },
  methods: {
    lockBackgroundScroll() {
      const appElement = document.getElementById('app')

      this.scrollLockState = {
        bodyOverflow: document.body.style.overflow,
        documentOverflow: document.documentElement.style.overflow,
        appOverflow: appElement ? appElement.style.overflow : '',
      }

      document.body.style.overflow = 'hidden'
      document.documentElement.style.overflow = 'hidden'
      if (appElement) {
        appElement.style.overflow = 'hidden'
      }
    },
    unlockBackgroundScroll() {
      if (!this.scrollLockState) return

      const appElement = document.getElementById('app')

      document.body.style.overflow = this.scrollLockState.bodyOverflow
      document.documentElement.style.overflow = this.scrollLockState.documentOverflow
      if (appElement) {
        appElement.style.overflow = this.scrollLockState.appOverflow
      }
    },
    isImage(filePath) {
      if (!filePath) return false
      const ext = filePath.split('.').pop().split('?')[0].toLowerCase()
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'tiff', 'svg', 'heic', 'heif', 'ico']
      const videoExtensions = ['mp4', 'avi', 'mov', 'mkv', 'webm', 'flv', 'wmv', 'mpg', 'mpeg']
      if (imageExtensions.includes(ext)) return true
      if (videoExtensions.includes(ext)) return false

      return !this.failedImages[filePath]
    },
    isVideo(filePath) {
      if (!filePath) return false
      const ext = filePath.split('.').pop().split('?')[0].toLowerCase()
      const videoExtensions = ['mp4', 'avi', 'mov', 'mkv', 'webm', 'flv', 'wmv', 'mpg', 'mpeg']
      if (videoExtensions.includes(ext)) return true

      return !!this.failedImages[filePath]
    },
    onImgError(filePath) {
      this.$set(this.failedImages, filePath, true)
    },
    displayFileAt(i) {
      if (i === this.selectedZoomIndex && this.modals.file.zoomUrl) {
        return this.modals.file.zoomUrl
      }

      return this.relatedFiles[i] || ''
    },
    rotatePositionAt(i) {
      const rotatePositions = this.modals.file.rotate_position || []

      return rotatePositions[i] || 0
    },
    toggleOriginalSize() {
      this.originalSize = !this.originalSize
    },
    prevImage() {
      const total = this.relatedFiles.length
      if (!total) return
      this.currentIndex = (this.currentIndex - 1 + total) % total
    },
    nextImage() {
      const total = this.relatedFiles.length
      if (!total) return
      this.currentIndex = (this.currentIndex + 1) % total
    },
    getVideoType(filePath) {
      const ext = filePath.split('.').pop().split('?')[0].toLowerCase()
      const types = {
        mp4: 'video/mp4',
        webm: 'video/webm',
        avi: 'video/avi',
        mov: 'video/quicktime',
        mkv: 'video/x-matroska',
        flv: 'video/x-flv',
        wmv: 'video/x-ms-wmv',
        mpg: 'video/mpeg',
        mpeg: 'video/mpeg',
      }

      return types[ext] || 'video/mp4'
    },
    callIframe() {
      const iframe = document.getElementById('inner_iframe')
      const self = this
      let iWindow = null
      iframe.addEventListener('load', () => {
        iWindow = iframe.contentWindow
        if (iWindow === null) {
          self.callIframe()
        }
        iWindow.postMessage(['book-infos', { related_files: this.modals.file.related_files, rotate_position: this.modals.file.rotate_position }])
      })
    },
    formatDate(date) {
      if (!date) return null
      const parsed = new Date(date.length === 10 ? `${date}T12:00:00Z` : date)

      return Number.isNaN(parsed.getTime()) ? date : parsed.toLocaleDateString(this.$locale(), {
        month: 'short', year: 'numeric', day: 'numeric', timeZone: 'UTC',
      })
    },
  },
}
</script>

<style scoped lang="scss">
  .modal-zoom {
    height: 100%;
    overflow: hidden;

    .v-card {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }

    .v-card__actions {
      flex: 0 0 auto;
    }
  }

  .theme--light.v-card {
    background: #000;
    color: #fff !important
  }
  .v-card__text {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    padding: 0 !important;
    position: relative;

    > div {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    img {
      display: block;
      margin: 0 auto;
      width: 100%;
      height: 100%;
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
      border-radius: 12px;
    }

    .v-carousel {
      width: 100%;
      height: 100% !important;
      background: transparent;

      .v-carousel__item,
      .v-window-item,
      .v-window__container {
        height: 100% !important;
      }

      .v-responsive,
      .v-responsive__content {
        height: 100% !important;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      img {
        width: 100%;
        height: 100%;
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
      }
    }

    .iframe-modal {
      width: 75vw;
      height: 100%;
    }
  }

  .v-card__text.original-size {
    overflow: auto;
    justify-content: flex-start;
    align-items: flex-start;

    > div {
      width: auto;
      height: auto;
      min-width: 100%;
      min-height: 100%;
      display: block;
    }

    img {
      width: auto !important;
      height: auto !important;
      max-width: none !important;
      max-height: none !important;
      margin: 0 auto;
      object-fit: initial;
    }

    .v-carousel,
    .v-carousel .v-window__container,
    .v-carousel .v-responsive,
    .v-carousel .v-responsive__content {
      height: auto !important;
      min-height: 100%;
      overflow: visible !important;
      display: block !important;
    }

    // Active slide (no inline display:none) expands to content; inactive
    // siblings keep Vuetify's inline `display: none` so they stay hidden.
    .v-carousel .v-window-item:not([style*="display: none"]) {
      display: block !important;
      height: auto !important;
      min-height: 100%;
      overflow: visible !important;
    }

    .v-carousel .v-responsive__content {
      text-align: center;
    }

    .v-carousel img {
      display: inline-block;
    }
  }

  .btn-original-size {
    position: fixed;
    top: 16px;
    right: 16px;
    z-index: 20;
  }

  .nav-arrow {
    position: fixed;
    top: 50%;
    transform: translateY(-50%);
    z-index: 20;
    background-color: rgba(0, 0, 0, 0.5) !important;

    &.nav-arrow-prev {
      left: 16px;
    }

    &.nav-arrow-next {
      right: 16px;
    }
  }

  .v-dialog {
    .v-divider + .v-card__actions {
      background: #000 !important;
    }
  }

</style>
